import {
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@repo/shadcn';
import { useFormContext } from 'react-hook-form';

import { TCreatePrePurchaseForm } from './create-pre-purchase.schema';
import { CreatePurchaseItem } from './item.component';
import { usePrePurchaseItemsFieldArrayContext } from './items-field-array.context';

export const CreatePurchaseItemList = () => {
    const { watch } = useFormContext<TCreatePrePurchaseForm>();
    const { fields, remove } = usePrePurchaseItemsFieldArrayContext();

    const items = watch('items') || [];

    const renderTableRows = () => {
        // items = 0;
        //
        // if (items) {
        // }

        if (fields.length === 0) {
            return (
                <TableRow>
                    <TableCell colSpan={9} className="py-4 text-center">
                        No items added.
                    </TableCell>
                </TableRow>
            );
        }

        // items ? items : []
        // items || []
        // items ?? []

        return fields.map((field, index) => (
            <CreatePurchaseItem
                item={items[index] ?? field}
                serialNumber={index + 1}
                key={field.id}
                onRemove={() => remove(index)}
            />
        ));
    };

    return (
        <div className="w-full max-w-full touch-pan-x overflow-x-scroll pb-2">
            <table className="w-full min-w-[600px] text-[11px] sm:min-w-[680px] sm:text-xs">
                <TableHeader className={'rounded-md bg-white'}>
                    <TableRow>
                        <TableHead className="h-8 w-7 px-0.5 sm:h-9 sm:w-8 sm:px-1">
                            SL.
                        </TableHead>
                        <TableHead className="h-8 min-w-24 px-0.5 text-left sm:h-9 sm:min-w-28 sm:px-1">
                            Name
                        </TableHead>
                        <TableHead className="h-8 min-w-20 px-0.5 sm:h-9 sm:min-w-24 sm:px-1">
                            Expiry Date
                        </TableHead>
                        <TableHead className="h-8 w-12 px-0.5 text-right sm:h-9 sm:w-14 sm:px-1">
                            Quantity
                        </TableHead>
                        <TableHead className="h-8 w-14 px-0.5 text-right sm:h-9 sm:w-16 sm:px-1">
                            PP
                        </TableHead>
                        <TableHead className="h-8 w-14 px-0.5 text-right sm:h-9 sm:w-16 sm:px-1">
                            WP
                        </TableHead>
                        <TableHead className="h-8 w-14 px-0.5 text-right sm:h-9 sm:w-16 sm:px-1">
                            MRP
                        </TableHead>
                        <TableHead className="h-8 w-16 px-0.5 text-right sm:h-9 sm:w-[72px] sm:px-1">
                            Total
                        </TableHead>
                        <TableHead className="h-8 w-12 px-0.5 text-right sm:h-9 sm:w-14 sm:px-1">
                            Actions
                        </TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>{renderTableRows()}</TableBody>
            </table>
        </div>
    );
};

CreatePurchaseItemList.displayName = 'CreatePurchaseItemList';
